import { useState, useEffect } from "react";
import { C, CATS, getCat, DEBT_TYPES, getDebt, fmt, todayStr, thisMonthStr, calcPayoff } from "./constants";
import { Card, Label, Tag, Btn, Inp, Sel, ProgressBar } from "./ui";

function RecurringTab({ recurring, setRecurring, onApplyMonth, month, getRecurStatus, confirmRecurring, skipRecurring }) {
  const [modal, setModal]           = useState(false);
  const [showAllPending, setShowAllPending] = useState(false);
  const [name,  setName]  = useState("");
  const [amt,   setAmt]   = useState("");
  const [cat,   setCat]   = useState("Subscriptions");
  const [day,   setDay]   = useState(1);
  const type = "expense";

  const add = () => {
    if (!name || !amt) return;
    const catObj = getCat(cat);
    setRecurring(prev => [...prev, {
      id: Date.now(), name, amount: parseFloat(amt), category: cat,
      icon: catObj.icon, color: catObj.color, dayOfMonth: Number(day), type,
      active: true,
    }]);
    setModal(false); setName(""); setAmt(""); setCat("Subscriptions"); setDay(1);
  };

  const toggle = (id) => setRecurring(prev => prev.map(r => r.id===id ? {...r, active:!r.active} : r));
  const del    = (id) => setRecurring(prev => prev.filter(r => r.id!==id));

  const monthlyOut = recurring.filter(r=>r.active&&r.type!=="income").reduce((s,r)=>s+r.amount,0);

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:18 }}>
        <div>
          <div style={{ color:C.text, fontSize:18, fontWeight:800, letterSpacing:"-0.02em", marginBottom:3 }}>🔁 Recurring</div>
          <div style={{ color:C.text3, fontSize:12 }}>
            {recurring.length === 0 ? "No bills added yet" : `${fmt(monthlyOut)}/mo in active bills`}
          </div>
        </div>
        <Btn onClick={() => setModal(p=>!p)} style={{ padding:"7px 14px", fontSize:12 }}>{modal ? "✕ Close" : "+ Add"}</Btn>
      </div>

      {/* Add form — at the TOP, slides open */}
      <div style={{
        overflow:"hidden",
        maxHeight: modal ? "400px" : "0px",
        opacity: modal ? 1 : 0,
        transition:"max-height 0.35s ease, opacity 0.25s ease",
        marginBottom: modal ? 14 : 0,
      }}>
        <div style={{ background:C.surface3, border:`1px solid ${C.border2}`, borderRadius:14, padding:16 }}>
          <div style={{ color:C.text, fontWeight:600, marginBottom:12 }}>New Recurring Entry</div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
            <Inp label="Name" placeholder="Netflix, Rent…" value={name} onChange={e=>setName(e.target.value)} />
            <Inp label="Amount" type="number" placeholder="0.00" value={amt} onChange={e=>setAmt(e.target.value)} />
            <Sel label="Category" value={cat} onChange={e=>setCat(e.target.value)}>
              {CATS.map(c => <option key={c.id} value={c.id}>{c.icon} {c.id}</option>)}
            </Sel>
            <Inp label="Day of Month" type="number" min="1" max="31" value={day} onChange={e=>setDay(e.target.value)} />
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <Btn onClick={add}>Save</Btn>
            <Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn>
          </div>
        </div>
      </div>

      {/* ── PENDING BANNER ── */}
      {(() => {
        const pending = recurring.filter(r => r.active && getRecurStatus && getRecurStatus(r, month) === 'pending');
        if (pending.length === 0) return null;
        const shown = showAllPending ? pending : pending.slice(0, 3);
        const hasMore = pending.length > 3;
        return (
          <div style={{ background:"linear-gradient(135deg,rgba(251,191,36,0.1),rgba(245,166,35,0.06))", border:`1px solid rgba(251,191,36,0.3)`, borderRadius:14, padding:"14px 16px", marginBottom:14 }}>
            {/* Header row */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10 }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ fontSize:18 }}>🔔</span>
                <span style={{ color:C.amber, fontWeight:700, fontSize:15 }}>{pending.length} payment{pending.length>1?"s":""} pending this month</span>
              </div>
              {hasMore && (
                <button onClick={() => setShowAllPending(p=>!p)}
                  style={{ background:"none", border:"none", color:C.green, fontSize:11, fontWeight:600, cursor:"pointer" }}>
                  {showAllPending ? "Show less ↑" : `See all ${pending.length} ↓`}
                </button>
              )}
            </div>
            {/* Compact rows */}
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {shown.map(r => (
                <div key={r.id} style={{ background:"rgba(0,0,0,0.2)", borderRadius:12, padding:"12px 14px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <span style={{ fontSize:18, flexShrink:0 }}>{r.icon}</span>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ color:C.text, fontSize:13, fontWeight:600, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{r.name}</div>
                      <div style={{ color:C.text3, fontSize:11, marginTop:1 }}>Due day {r.dayOfMonth} · <span style={{ color:C.red, fontWeight:600 }}>{fmt(r.amount)}</span></div>
                    </div>
                    <div style={{ display:"flex", gap:6, flexShrink:0 }}>
                      <button onClick={() => confirmRecurring(r, month)}
                        style={{ background:"rgba(61,214,140,0.12)", border:`1px solid rgba(61,214,140,0.4)`, color:C.green, borderRadius:8, padding:"5px 11px", fontSize:12, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                        ✓ Paid
                      </button>
                      <button onClick={() => skipRecurring(r, month)}
                        style={{ background:"rgba(240,82,82,0.08)", border:`1px solid rgba(240,82,82,0.3)`, color:C.red, borderRadius:8, padding:"5px 11px", fontSize:12, fontWeight:600, cursor:"pointer" }}>
                        Skip
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* Bottom show less button */}
            {hasMore && showAllPending && (
              <button onClick={() => setShowAllPending(false)}
                style={{ width:"100%", marginTop:10, background:"none", border:`1px solid ${C.border}`, color:C.text3, borderRadius:8, padding:"7px", fontSize:11, cursor:"pointer" }}>
                Show less ↑
              </button>
            )}
          </div>
        );
      })()}

      {recurring.length === 0 && !modal && (
        <div style={{ textAlign:"center", padding:"32px 0", color:C.text3, fontSize:13 }}>
          <div style={{ fontSize:28, marginBottom:8 }}>🔁</div>
          <div style={{ color:C.text2, fontWeight:600, marginBottom:4 }}>No bills tracked yet</div>
          Add rent, utilities, and subscriptions — they'll appear in your calendar automatically each month. Every dirham tracked is an amanah honoured.
        </div>
      )}

      {/* List */}
      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {recurring.map(r => {
          const status = getRecurStatus ? getRecurStatus(r, month) : 'pending';
          const statusColor = status==='confirmed' ? C.green : status==='skipped' ? C.text3 : C.amber;
          const statusLabel = status==='confirmed' ? '✓ Paid' : status==='skipped' ? '— Skipped' : '🔔 Pending';
          return (
            <div key={r.id} style={{ background:C.surface2, border:`1px solid ${status==='pending' && r.active ? 'rgba(251,191,36,0.35)' : C.border}`, borderRadius:14, padding:"16px 16px", opacity: r.active ? 1 : 0.4 }}>
              {/* Row 1: icon + name/subtitle + amount */}
              <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:12 }}>
                <div style={{ fontSize:22, flexShrink:0 }}>{r.icon}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ color:C.text, fontSize:15, fontWeight:600, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{r.name}</div>
                  <div style={{ color:C.text3, fontSize:12, marginTop:2 }}>
                    Every month on day <span style={{ color:r.color, fontWeight:600 }}>{r.dayOfMonth}</span>
                    {" · "}
                    <span style={{ color: r.active ? r.color : C.text3 }}>{r.active ? "Active" : "Paused"}</span>
                  </div>
                </div>
                <div style={{ color: r.type==="income" ? C.green : C.red, fontWeight:700, fontSize:16, flexShrink:0 }}>
                  {r.type==="income" ? "+" : "-"}{fmt(r.amount)}
                </div>
              </div>
              {/* Row 2: status badge + buttons */}
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                <div>
                  {r.active && <span style={{ color:statusColor, fontSize:12, fontWeight:700 }}>{statusLabel}</span>}
                </div>
                <div style={{ display:"flex", gap:6, flexShrink:0 }}>
                  <button onClick={() => toggle(r.id)} style={{ background:"rgba(255,255,255,0.05)", border:`1px solid ${C.border}`, color:C.text3, borderRadius:8, padding:"7px 14px", fontSize:12, cursor:"pointer" }}>
                    {r.active ? "Pause" : "Resume"}
                  </button>
                  <button onClick={() => del(r.id)} style={{ background:C.redDim, border:`1px solid rgba(240,82,82,0.3)`, color:C.red, borderRadius:8, padding:"7px 11px", fontSize:12, cursor:"pointer" }}>✕</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>



    </div>
  );
}

// ── NET WORTH / SAVINGS TAB ───────────────────────────────────
function NetWorthTab({ transactions, goals, netWorthData, setNetWorthData }) {
  // Goals + unallocated surplus = complete savings picture
  const allTimeIncome   = transactions.filter(t => t.amount > 0).reduce((s,t) => s + t.amount, 0);
  const allTimeExpenses = transactions.filter(t => t.amount < 0).reduce((s,t) => s + Math.abs(t.amount), 0);
  const goalsBase    = goals.reduce((s,g) => s + (g.saved||0), 0);
  const allTimeTxNet = allTimeIncome - allTimeExpenses;
  const unallocated  = Math.max(0, allTimeTxNet - goalsBase);
  const txNetSavings = goalsBase + unallocated; // = allTimeTxNet (but split for display)

  // Manual adjustments log
  const [adjustments, setAdjustments] = useState(() => netWorthData.adjustments || []);
  const [form, setForm] = useState({ type:"+", amount:"", note:"", date:todayStr() });
  const [showForm, setShowForm] = useState(false);

  const totalAdj = adjustments.reduce((s,a) => s + (a.type==="+" ? a.amount : -a.amount), 0);
  const netSavings = txNetSavings + totalAdj;

  // Persist whenever adjustments change
  useEffect(() => {
    const updated = { adjustments };
    setNetWorthData(updated);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adjustments]);

  const addAdj = () => {
    const amt = parseFloat(form.amount);
    if (!amt || amt <= 0 || !form.note.trim()) return;
    const entry = { id: Date.now(), type: form.type, amount: amt, note: form.note.trim(), date: form.date };
    setAdjustments(prev => [entry, ...prev]);
    setForm({ type:"+", amount:"", note:"", date:todayStr() });
    setShowForm(false);
  };

  const delAdj = (id) => setAdjustments(prev => prev.filter(a => a.id !== id));

  const ADJ_TYPES = [
    { value:"-", label:"− Lent money",     icon:"🤝" },
    { value:"-", label:"− Cash withdrawn", icon:"💸" },
    { value:"-", label:"− Gift given",     icon:"🎁" },
    { value:"-", label:"− Asset bought",   icon:"🏷️" },
    { value:"+", label:"+ Loan repaid",    icon:"💰" },
    { value:"+", label:"+ Cash deposited", icon:"🏦" },
    { value:"+", label:"+ Asset sold",     icon:"📦" },
    { value:"+", label:"+ Other income",   icon:"✨" },
  ];

  return (
    <div>
      {/* Header summary */}
      <div style={{ background:`linear-gradient(135deg,rgba(96,165,250,0.1),rgba(96,165,250,0.04))`, border:`1px solid rgba(96,165,250,0.2)`, borderRadius:14, padding:"16px 18px", marginBottom:14 }}>
        <Label style={{ marginBottom:6 }}>Current Savings Balance</Label>
        <div style={{ fontSize:36, fontWeight:800, color: netSavings >= 0 ? C.green : C.red, letterSpacing:"-0.03em", marginBottom:10 }}>
          {netSavings >= 0 ? "" : "-"}{fmt(Math.abs(netSavings))}
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:6 }}>
          {[
            { label:"Goals",      val:fmt(goalsBase),    color:C.green  },
            { label:"Surplus",    val:fmt(unallocated),  color:C.blue   },
            { label:"Adj.",val:(totalAdj>=0?"+":"")+fmt(Math.abs(totalAdj)), color:totalAdj>=0?C.purple:C.amber },
          ].map(s => (
            <div key={s.label} style={{ background:"rgba(255,255,255,0.04)", borderRadius:10, padding:"8px 6px", textAlign:"center", minWidth:0 }}>
              <div style={{ color:C.text3, fontSize:8, textTransform:"uppercase", fontWeight:600, marginBottom:3, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{s.label}</div>
              <div style={{ color:s.color, fontSize:12, fontWeight:700, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{s.val}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Zakat link notice */}
      <div style={{ background:"rgba(251,191,36,0.06)", border:"1px solid rgba(251,191,36,0.15)", borderRadius:10, padding:"8px 14px", marginBottom:14, fontSize:11, color:C.gold }}>
        🌙 This net savings figure auto-feeds into your <strong>Zakat calculator</strong> as the savings value
      </div>

      {/* Add adjustment button */}
      <div style={{ marginBottom:12 }}>
        {!showForm ? (
          <Btn onClick={() => setShowForm(true)} style={{ width:"100%" }}>+ Add Adjustment</Btn>
        ) : (
          <div style={{ background:C.surface2, border:`1px solid ${C.border2}`, borderRadius:14, padding:14 }}>
            <div style={{ color:C.text, fontWeight:600, fontSize:13, marginBottom:12 }}>New Adjustment</div>

            {/* Quick type selector */}
            <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:12 }}>
              {ADJ_TYPES.map((t,i) => (
                <button key={i} onClick={() => setForm(p => ({ ...p, type:t.value, note:t.label.slice(2) }))}
                  style={{ background: form.note===t.label.slice(2) ? (t.value==="+" ? "rgba(61,214,140,0.15)" : "rgba(240,82,82,0.12)") : C.surface3,
                    border:`1px solid ${form.note===t.label.slice(2) ? (t.value==="+" ? "rgba(61,214,140,0.3)" : "rgba(240,82,82,0.25)") : C.border}`,
                    color: form.note===t.label.slice(2) ? (t.value==="+" ? C.green : C.red) : C.text3,
                    borderRadius:8, padding:"5px 10px", fontSize:11, cursor:"pointer" }}>
                  {t.icon} {t.label}
                </button>
              ))}
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:10 }}>
              {/* Type toggle */}
              <div>
                <Label>Type</Label>
                <div style={{ display:"flex", background:C.surface, borderRadius:10, padding:3, gap:3 }}>
                  {[["+","+ Add"],["−","− Subtract"]].map(([v,l]) => (
                    <button key={v} onClick={() => setForm(p=>({...p, type:v==="+"?"+":"-"}))}
                      style={{ flex:1, padding:"7px 6px", fontSize:11, fontWeight:600, cursor:"pointer", borderRadius:8, border:"none",
                        background: (form.type==="+" && v==="+") || (form.type==="-" && v==="−") ? (v==="+" ? "rgba(61,214,140,0.2)" : "rgba(240,82,82,0.2)") : "transparent",
                        color: (form.type==="+" && v==="+") || (form.type==="-" && v==="−") ? (v==="+" ? C.green : C.red) : C.text3 }}>
                      {l}
                    </button>
                  ))}
                </div>
              </div>
              <Inp label="Amount" type="number" placeholder="500" value={form.amount} onChange={e=>setForm(p=>({...p,amount:e.target.value}))} />
              <div style={{ gridColumn:"1/-1" }}>
                <Inp label="Note" placeholder="e.g. Lent to brother for rent" value={form.note} onChange={e=>setForm(p=>({...p,note:e.target.value}))} />
              </div>
              <Inp label="Date" type="date" value={form.date} onChange={e=>setForm(p=>({...p,date:e.target.value}))} />
            </div>

            <div style={{ display:"flex", gap:8 }}>
              <Btn onClick={addAdj} disabled={!form.amount||!form.note.trim()}>Save</Btn>
              <Btn variant="ghost" onClick={() => { setShowForm(false); setForm({ type:"+", amount:"", note:"", date:todayStr() }); }}>Cancel</Btn>
            </div>
          </div>
        )}
      </div>

      {/* Adjustments log */}
      {adjustments.length === 0 && !showForm && (
        <div style={{ textAlign:"center", padding:"24px 0", color:C.text3, fontSize:13 }}>
          <div style={{ fontSize:28, marginBottom:8 }}>📒</div>
          No adjustments yet. Use this to track money lent, gifts given, cash withdrawn, assets bought, etc.
        </div>
      )}

      {adjustments.length > 0 && (
        <div>
          <Label style={{ marginBottom:8 }}>Adjustment Log</Label>
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            {adjustments.map(a => (
              <div key={a.id} style={{ display:"flex", alignItems:"center", gap:10, background:C.surface2, border:`1px solid ${C.border}`, borderRadius:12, padding:"10px 14px" }}>
                <div style={{ fontSize:20 }}>{a.type==="+" ? "💰" : "💸"}</div>
                <div style={{ flex:1 }}>
                  <div style={{ color:C.text, fontSize:13, fontWeight:600 }}>{a.note}</div>
                  <div style={{ color:C.text3, fontSize:10, marginTop:2 }}>{a.date}</div>
                </div>
                <div style={{ color: a.type==="+" ? C.green : C.red, fontWeight:800, fontSize:14 }}>
                  {a.type==="+" ? "+" : "−"}{fmt(a.amount)}
                </div>
                <button onClick={() => delAdj(a.id)} style={{ background:"none", border:"none", color:C.text3, cursor:"pointer", fontSize:13, padding:"2px 4px" }}
                  onMouseOver={e=>e.target.style.color=C.red} onMouseOut={e=>e.target.style.color=C.text3}>✕</button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── ZAKAT CALCULATOR ─────────────────────────────────────────
function ZakatTab({ zakatData, setZakatData, transactions, debtState, netSavings, proUser, openUpgrade, addTx, settings, setSettings }) {
  const STATIC_NISAB = 595 * 0.95; // ~$565 silver standard fallback
  const [allMadhabs, setAllMadhabs] = useState(null);
  const [nisabLoading, setNisabLoading] = useState(false);
  const [hijriDate, setHijriDate] = useState(null);

  // Settings-backed toggles (all users)
  const nisabStandard = settings?.nisabStandard || "silver"; // "silver" | "gold"
  const hanafiSilver  = settings?.hanafiSilver !== false;    // default true (Hanafi 612g)
  const debtMethod    = settings?.zakatDebtMethod || "annual"; // "annual" | "full" | "none"

  // Derive live nisab from allMadhabs data
  const currency = settings?.currency || "CAD";
  const liveNisabGold   = allMadhabs?.hanafi?.gold?.values?.[currency] ?? null;
  const liveNisabSilver = allMadhabs
    ? ((hanafiSilver ? allMadhabs.hanafi : allMadhabs.maliki)?.silver?.values?.[currency] ?? null)
    : null;
  const liveNisab = nisabStandard === "gold" ? liveNisabGold : liveNisabSilver;
  const NISAB = liveNisab ?? STATIC_NISAB;

  // Fetch live nisab for ALL users — accurate Zakat is a religious obligation
  useEffect(() => {
    setNisabLoading(true);
    fetch(`/api/gold-price?currency=${currency}`)
      .then(r => r.json())
      .then(data => {
        if (data?.allMadhabs) setAllMadhabs(data.allMadhabs);
        else if (data?.nisabCAD) {
          // Fallback: legacy API shape — wrap into allMadhabs structure
          setAllMadhabs({ hanafi: { silver: { values: { CAD: data.nisabCAD } }, gold: { values: { CAD: data.nisabCAD } } }, maliki: { silver: { values: { CAD: data.nisabCAD } } } });
        }
        if (data?.hijriDate) setHijriDate(data.hijriDate);
      })
      .catch(() => {})
      .finally(() => setNisabLoading(false));
  }, [currency]);

  // ── LIVE AUTO VALUES (always fresh from app data) ─────────────
  // Goals total = money currently set aside. Adjustments reduce it (lent, gifted, withdrawn).
  const autoSavings = Math.max(0, netSavings);

  const autoInvestments = transactions
    .filter(t => t.amount < 0 && (
      t.expenseCategory === "Investment" ||
      ["invest","wealthsimple","etf","wahed","zoya","mutual fund"].some(kw =>
        (t.description || "").toLowerCase().includes(kw))
    ))
    .reduce((s, t) => s + Math.abs(t.amount), 0);

  // Debt deduction — method controlled by zakatDebtMethod setting
  const autoLiabilities = (() => {
    const allDebts = debtState.debts || [];
    if (debtMethod === "none") return 0;
    if (debtMethod === "full") return allDebts.reduce((s, d) => s + (d.currentBalance || 0), 0);
    // "annual" — 12 × monthly minimum payment (Zakat Foundation / NZF / Islamic Relief method)
    return allDebts.reduce((s, d) => {
      if (!d.minPayment || d.minPayment <= 0) return s;
      return s + Math.min(d.minPayment * 12, d.currentBalance || 0);
    }, 0);
  })();

  const currentYear = new Date().getFullYear().toString();
  const sadaqahPaid = transactions
    .filter(t => t.amount < 0 && t.expenseCategory === "Sadaqah" && t.date.startsWith(currentYear))
    .reduce((s, t) => s + Math.abs(t.amount), 0);

  // Zakat history
  const [zakatHistory, setZakatHistory] = useState(() => {
    try { return JSON.parse(localStorage.getItem("bb_zakat_history_v1") || "[]"); } catch { return []; }
  });
  const [showMarkPaid, setShowMarkPaid] = useState(false);
  const [paidTo, setPaidTo] = useState("");
  const [paidNote, setPaidNote] = useState("");

  // Manual-only fields (user must type)
  const [manual, setManual] = useState(() => {
    const z = zakatData || {};
    return {
      cash:        z.cash        || "",
      gold:        z.gold        || "",
      receivables: z.receivables || "",
      business:    z.business    || "",
    };
  });
  // Overrides for auto fields (empty = use live auto value)
  const [overrides, setOverrides] = useState(() => {
    const z = zakatData || {};
    return {
      savings:     z._savOvr     || "",
      investments: z._invOvr     || "",
      liabilities: z._liabOvr    || "",
    };
  });

  const updManual = (k, v) => {
    const n = { ...manual, [k]: v };
    setManual(n);
    persist(n, overrides);
  };
  const updOverride = (k, v) => {
    const n = { ...overrides, [k]: v };
    setOverrides(n);
    persist(manual, n);
  };
  const resetOverride = (k) => updOverride(k, "");
  const persist = (m, o) => setZakatData({
    ...m, _savOvr: o.savings, _invOvr: o.investments, _liabOvr: o.liabilities
  });

  // Effective values — override beats auto
  const effSavings     = overrides.savings     !== "" ? parseFloat(overrides.savings)     || 0 : autoSavings;
  const effInvestments = overrides.investments !== "" ? parseFloat(overrides.investments) || 0 : autoInvestments;
  const effLiabilities = overrides.liabilities !== "" ? parseFloat(overrides.liabilities) || 0 : autoLiabilities;
  const effCash        = parseFloat(manual.cash)        || 0;
  const effGold        = parseFloat(manual.gold)        || 0;
  const effReceivables = parseFloat(manual.receivables) || 0;
  const effBusiness    = parseFloat(manual.business)    || 0;

  const totalAssets  = effCash + effSavings + effGold + effInvestments + effReceivables + effBusiness;
  const netWorth     = totalAssets - effLiabilities;
  const zakatDue     = netWorth >= NISAB ? netWorth * 0.025 : 0;
  const aboveNisab   = netWorth >= NISAB;

  const nextDueDate = (() => {
    const last = zakatHistory[0];
    if (!last) return null;
    const d = new Date(last.date + "T00:00:00");
    d.setFullYear(d.getFullYear() + 1);
    return d.toLocaleDateString("en-CA", { year:"numeric", month:"long", day:"numeric" });
  })();

  const markZakatPaid = () => {
    if (!zakatDue) return;
    const today = todayStr();
    const entry = { id: Date.now(), date: today, amount: zakatDue, to: paidTo, note: paidNote, year: new Date().getFullYear() };
    const updated = [entry, ...zakatHistory];
    setZakatHistory(updated);
    localStorage.setItem("bb_zakat_history_v1", JSON.stringify(updated));
    const desc = paidTo ? `Zakat · ${paidTo}` : "Zakat payment";
    addTx({ id: Date.now() + 1, date: today, amount: -zakatDue, description: desc, expenseCategory: "Sadaqah", category: "Sadaqah", icon: "🤲", cardId: null });
    setShowMarkPaid(false); setPaidTo(""); setPaidNote("");
  };

  // Auto fields config
  const autoFields = [
    { key:"savings",     icon:"🏦", label:"Bank savings",    val:autoSavings,     ov:overrides.savings     },
    { key:"investments", icon:"📈", label:"Investments",     val:autoInvestments, ov:overrides.investments },
    { key:"liabilities", icon:"💳", label:"Riba debts owed", val:autoLiabilities, ov:overrides.liabilities },
  ];
  // Manual fields config
  const inputStyle = (isAutoActive, isEdited) => ({
    width:"100%",
    background: isAutoActive ? "rgba(61,214,140,0.05)" : C.surface2,
    border:"1px solid " + (isAutoActive ? "rgba(61,214,140,0.25)" : isEdited ? "rgba(245,166,35,0.35)" : "rgba(255,255,255,0.12)"),
    borderRadius:10, color:C.text, fontSize:13, padding:"8px 11px", outline:"none",
  });

  // Debt method descriptions
  const DEBT_METHOD_OPTS = [
    { key:"annual",   label:"Annual",       desc:"Deducts 12 × monthly minimum payment — what's due this year. Used by Zakat Foundation, NZF, Islamic Relief." },
    { key:"full",     label:"Full Balance", desc:"Deducts full outstanding balance. ISNA/AMJA position. Note: scholarly disagreement exists." },
    { key:"none",     label:"None",         desc:"No debt deduction — Zakat on your full wealth. Shafi'i school and some contemporary scholars." },
  ];
  const selectedDebtOpt = DEBT_METHOD_OPTS.find(o => o.key === debtMethod) || DEBT_METHOD_OPTS[0];

  const pillBtn = (active) => ({
    flex:1, padding:"7px 4px", fontSize:11, fontWeight:600, cursor:"pointer", borderRadius:8, border:"none",
    background: active ? "rgba(251,191,36,0.18)" : "transparent",
    color: active ? C.gold : C.text3,
    transition:"all 0.15s",
  });

  return (
    <div>
      {/* Header */}
      <div style={{ background:"linear-gradient(135deg,rgba(251,191,36,0.08),rgba(251,191,36,0.03))", border:"1px solid rgba(251,191,36,0.2)", borderRadius:14, padding:"14px 16px", marginBottom:12 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10, flex:1, marginBottom:10 }}>
          <div style={{ fontSize:26 }}>🌙</div>
          <div style={{ flex:1 }}>
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <span style={{ color:C.gold, fontWeight:700, fontSize:14 }}>Zakat Calculator</span>
              <span style={{ background:"rgba(61,214,140,0.15)", color:C.green, fontSize:9, fontWeight:700, letterSpacing:"0.06em", padding:"2px 7px", borderRadius:20 }}>FREE</span>
            </div>
            <div style={{ color:C.text3, fontSize:11, marginTop:2 }}>
              {nisabLoading
                ? "Fetching live prices…"
                : liveNisab
                  ? <span>Nisab <strong style={{color:C.gold}}>{fmt(liveNisab)}</strong> · <span style={{color:C.green, fontSize:10}}>● Live</span></span>
                  : <span>Nisab ~{fmt(STATIC_NISAB)} · <span style={{color:C.amber}}>using fallback</span></span>
              }
            </div>
            {hijriDate && (
              <div style={{ color:C.text3, fontSize:10, marginTop:3 }}>🗓 {hijriDate}</div>
            )}
          </div>
        </div>

        {/* Nisab standard toggle — gold vs silver */}
        <div style={{ marginBottom:10 }}>
          <div style={{ color:C.text3, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:6 }}>Nisab Standard</div>
          <div style={{ display:"flex", background:"rgba(0,0,0,0.3)", borderRadius:10, padding:3, gap:3 }}>
            <button style={pillBtn(nisabStandard === "silver")} onClick={() => setSettings && setSettings({...settings, nisabStandard:"silver"})}>
              🥈 Silver (recommended)
            </button>
            <button style={pillBtn(nisabStandard === "gold")} onClick={() => setSettings && setSettings({...settings, nisabStandard:"gold"})}>
              🥇 Gold
            </button>
          </div>
          {nisabStandard === "silver" && (
            <div style={{ marginTop:6 }}>
              <div style={{ color:C.text3, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:4 }}>School (Silver Weight)</div>
              <div style={{ display:"flex", background:"rgba(0,0,0,0.3)", borderRadius:10, padding:3, gap:3 }}>
                <button style={pillBtn(hanafiSilver)} onClick={() => setSettings && setSettings({...settings, hanafiSilver:true})}>Hanafi (612g)</button>
                <button style={pillBtn(!hanafiSilver)} onClick={() => setSettings && setSettings({...settings, hanafiSilver:false})}>Maliki/Shafi'i/Hanbali (595g)</button>
              </div>
            </div>
          )}
        </div>

        {/* Debt deduction method */}
        <div>
          <div style={{ color:C.text3, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:6 }}>Debt Deduction Method</div>
          <div style={{ display:"flex", background:"rgba(0,0,0,0.3)", borderRadius:10, padding:3, gap:3 }}>
            {DEBT_METHOD_OPTS.map(opt => (
              <button key={opt.key} style={pillBtn(debtMethod === opt.key)}
                onClick={() => setSettings && setSettings({...settings, zakatDebtMethod:opt.key})}>
                {opt.label}
              </button>
            ))}
          </div>
          <div style={{ color:C.text3, fontSize:10, lineHeight:1.5, marginTop:6 }}>{selectedDebtOpt.desc}</div>
        </div>
      </div>

      {/* Section label */}
      <div style={{ fontSize:10, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:C.text3, marginBottom:10 }}>Your Assets</div>

      {/* Single unified 2-col grid — all 7 fields in logical order */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:14 }}>

        {/* Cash — manual */}
        <div>
          <div style={{ fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3, marginBottom:6, minHeight:18, display:"flex", alignItems:"center" }}>💵 Cash in hand</div>
          <input type="number" placeholder="0.00" value={manual.cash}
            onChange={e => updManual("cash", e.target.value)}
            style={inputStyle(false, false)} />
        </div>

        {/* Bank savings — auto */}
        {(() => { const f = autoFields[0]; const isActive = f.ov===""; return (
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:4, marginBottom:6, minHeight:18 }}>
              <span style={{ fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3 }}>🏦 Bank savings</span>
              {isActive ? <span style={{ background:"rgba(61,214,140,0.15)", color:C.green, fontSize:8, fontWeight:700, borderRadius:4, padding:"1px 5px" }}>AUTO</span>
                        : <span style={{ background:"rgba(245,166,35,0.15)", color:C.amber, fontSize:8, fontWeight:700, borderRadius:4, padding:"1px 5px" }}>EDITED</span>}
            </div>
            <div style={{ position:"relative" }}>
              <input type="number" placeholder={f.val.toFixed(0)} value={f.ov}
                onChange={e => updOverride("savings", e.target.value)}
                style={inputStyle(isActive, !isActive)} />
              {!isActive && <button onClick={()=>resetOverride("savings")} style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:C.text3, fontSize:9, cursor:"pointer" }}>↺</button>}
            </div>
          </div>
        );})()}

        {/* Gold & silver — manual */}
        <div>
          <div style={{ fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3, marginBottom:6, minHeight:18, display:"flex", alignItems:"center" }}>🥇 Gold & silver ($)</div>
          <input type="number" placeholder="0.00" value={manual.gold}
            onChange={e => updManual("gold", e.target.value)}
            style={inputStyle(false, false)} />
        </div>

        {/* Investments — auto */}
        {(() => { const f = autoFields[1]; const isActive = f.ov===""; return (
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:4, marginBottom:6, minHeight:18 }}>
              <span style={{ fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3 }}>📈 Investments</span>
              {isActive ? <span style={{ background:"rgba(61,214,140,0.15)", color:C.green, fontSize:8, fontWeight:700, borderRadius:4, padding:"1px 5px" }}>AUTO</span>
                        : <span style={{ background:"rgba(245,166,35,0.15)", color:C.amber, fontSize:8, fontWeight:700, borderRadius:4, padding:"1px 5px" }}>EDITED</span>}
            </div>
            <div style={{ position:"relative" }}>
              <input type="number" placeholder={f.val.toFixed(0)} value={f.ov}
                onChange={e => updOverride("investments", e.target.value)}
                style={inputStyle(isActive, !isActive)} />
              {!isActive && <button onClick={()=>resetOverride("investments")} style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:C.text3, fontSize:9, cursor:"pointer" }}>↺</button>}
            </div>
          </div>
        );})()}

        {/* Receivables — manual */}
        <div>
          <div style={{ fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3, marginBottom:6, minHeight:18, display:"flex", alignItems:"center" }}>🤝 Money owed to you</div>
          <input type="number" placeholder="0.00" value={manual.receivables}
            onChange={e => updManual("receivables", e.target.value)}
            style={inputStyle(false, false)} />
        </div>

        {/* Business — manual */}
        <div>
          <div style={{ fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3, marginBottom:6, minHeight:18, display:"flex", alignItems:"center" }}>🏪 Business assets</div>
          <input type="number" placeholder="0.00" value={manual.business}
            onChange={e => updManual("business", e.target.value)}
            style={inputStyle(false, false)} />
        </div>

        {/* Liabilities — auto, full width */}
        {(() => { const f = autoFields[2]; const isActive = f.ov===""; return (
          <div style={{ gridColumn:"1 / -1" }}>
            <div style={{ display:"flex", alignItems:"center", gap:4, marginBottom:6, minHeight:18 }}>
              <span style={{ fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3 }}>📉 Debts you owe (subtract)</span>
              {isActive ? <span style={{ background:"rgba(61,214,140,0.15)", color:C.green, fontSize:8, fontWeight:700, borderRadius:4, padding:"1px 5px" }}>AUTO</span>
                        : <span style={{ background:"rgba(245,166,35,0.15)", color:C.amber, fontSize:8, fontWeight:700, borderRadius:4, padding:"1px 5px" }}>EDITED</span>}
            </div>
            <div style={{ position:"relative" }}>
              <input type="number" placeholder={f.val.toFixed(0)} value={f.ov}
                onChange={e => updOverride("liabilities", e.target.value)}
                style={inputStyle(isActive, !isActive)} />
              {!isActive && <button onClick={()=>resetOverride("liabilities")} style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:C.text3, fontSize:9, cursor:"pointer" }}>↺</button>}
            </div>
          </div>
        );})()}

      </div>

      {/* Result */}
      <div style={{ background: aboveNisab ? "rgba(251,191,36,0.08)" : C.surface2, border:"1px solid " + (aboveNisab ? "rgba(251,191,36,0.3)" : "rgba(255,255,255,0.07)"), borderRadius:14, padding:16, marginBottom:14 }}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom: zakatDue > 0 ? 12 : 0 }}>
          <div style={{ textAlign:"center" }}>
            <div style={{ color:C.text3, fontSize:9, textTransform:"uppercase", fontWeight:600, marginBottom:4 }}>Net Zakatable</div>
            <div style={{ color:C.text, fontSize:18, fontWeight:700 }}>{fmt(Math.max(0,netWorth))}</div>
          </div>
          <div style={{ textAlign:"center" }}>
            <div style={{ color:C.text3, fontSize:9, textTransform:"uppercase", fontWeight:600, marginBottom:4 }}>Nisab</div>
            <div style={{ color: aboveNisab ? C.green : C.text2, fontSize:18, fontWeight:700 }}>{aboveNisab ? "✓ Met" : "Not yet"}</div>
          </div>
          <div style={{ textAlign:"center" }}>
            <div style={{ color:C.text3, fontSize:9, textTransform:"uppercase", fontWeight:600, marginBottom:4 }}>Zakat Due (2.5%)</div>
            <div style={{ color:C.gold, fontSize:18, fontWeight:700 }}>{zakatDue > 0 ? fmt(zakatDue) : "—"}</div>
          </div>
        </div>
        {zakatDue > 0 && (
          <div style={{ background:"rgba(251,191,36,0.06)", borderRadius:10, padding:"10px 14px", textAlign:"center" }}>
            <div style={{ color:C.text2, fontSize:12 }}>Pay <strong style={{ color:C.gold }}>{fmt(zakatDue)}</strong> in Zakat this year</div>
            <div style={{ color:C.text3, fontSize:10, marginTop:4 }}>May Allah accept it from you 🤲</div>
          </div>
        )}
        {nextDueDate && (
          <div style={{ marginTop:10, textAlign:"center", color:C.text3, fontSize:11 }}>
            Next Zakat due: <strong style={{ color:C.text2 }}>{nextDueDate}</strong>
          </div>
        )}
        {!aboveNisab && netWorth > 0 && (
          <div style={{ color:C.text3, fontSize:12, textAlign:"center" }}>
            Need {fmt(NISAB - netWorth)} more to reach nisab threshold
          </div>
        )}
      </div>

      {/* Sadaqah counter */}
      <div style={{ background:C.surface2, border:"1px solid rgba(134,239,172,0.18)", borderRadius:12, padding:"12px 14px", display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12 }}>
        <div>
          <div style={{ color:"#86efac", fontSize:12, fontWeight:700, marginBottom:2 }}>🤲 Sadaqah paid in {currentYear}</div>
          <div style={{ color:C.text3, fontSize:10 }}>Auto-counted from 🤲 Sadaqah category transactions</div>
        </div>
        <div style={{ color:"#86efac", fontWeight:800, fontSize:18 }}>{fmt(sadaqahPaid)}</div>
      </div>

      {/* Zakat History — Pro only */}
      {proUser ? (
        <div>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ color:C.text, fontWeight:600, fontSize:13 }}>📋 Zakat History</div>
            {zakatDue > 0 && (
              <button onClick={() => setShowMarkPaid(true)}
                style={{ background:"rgba(251,191,36,0.12)", border:"1px solid rgba(251,191,36,0.3)",
                  color:C.gold, borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
                ✓ Mark as Paid
              </button>
            )}
          </div>

          {showMarkPaid && (
            <div style={{ background:C.surface2, border:"1px solid rgba(251,191,36,0.2)", borderRadius:12, padding:16, marginBottom:12 }}>
              <div style={{ color:C.text, fontWeight:600, marginBottom:10, fontSize:13 }}>Record Zakat Payment — {fmt(zakatDue)}</div>
              <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:12 }}>
                <div>
                  <div style={{ color:C.text3, fontSize:10, fontWeight:600, textTransform:"uppercase", marginBottom:4 }}>Paid To</div>
                  <input value={paidTo} onChange={e=>setPaidTo(e.target.value)} placeholder="e.g. Local mosque, Islamic Relief…"
                    style={{ width:"100%", background:C.surface, border:"1px solid rgba(255,255,255,0.1)", borderRadius:8,
                      padding:"9px 12px", color:C.text, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:"none" }} />
                </div>
                <div>
                  <div style={{ color:C.text3, fontSize:10, fontWeight:600, textTransform:"uppercase", marginBottom:4 }}>Note (optional)</div>
                  <input value={paidNote} onChange={e=>setPaidNote(e.target.value)} placeholder="Ramadan 2026…"
                    style={{ width:"100%", background:C.surface, border:"1px solid rgba(255,255,255,0.1)", borderRadius:8,
                      padding:"9px 12px", color:C.text, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:"none" }} />
                </div>
              </div>
              <div style={{ display:"flex", gap:8 }}>
                <button onClick={markZakatPaid}
                  style={{ flex:1, background:"rgba(251,191,36,0.15)", border:"1px solid rgba(251,191,36,0.3)",
                    color:C.gold, borderRadius:8, padding:"10px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
                  Record Payment
                </button>
                <button onClick={() => setShowMarkPaid(false)}
                  style={{ background:"none", border:"1px solid rgba(255,255,255,0.08)", color:C.text3,
                    borderRadius:8, padding:"10px 16px", fontSize:13, cursor:"pointer" }}>
                  Cancel
                </button>
              </div>
            </div>
          )}

          {zakatHistory.length === 0 ? (
            <div style={{ color:C.text3, fontSize:12, textAlign:"center", padding:"16px 0" }}>
              No Zakat recorded yet. When you pay, mark it here — Allah loves those who fulfil their obligations.
            </div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {zakatHistory.map(h => (
                <div key={h.id} style={{ background:C.surface2, border:"1px solid rgba(251,191,36,0.15)", borderRadius:10, padding:"10px 14px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                  <div>
                    <div style={{ color:C.gold, fontWeight:700, fontSize:13 }}>{fmt(h.amount)}</div>
                    <div style={{ color:C.text3, fontSize:10, marginTop:2 }}>{h.date}{h.to ? ` · ${h.to}` : ""}{h.note ? ` · ${h.note}` : ""}</div>
                  </div>
                  <div style={{ color:C.green, fontSize:11, fontWeight:600 }}>✓ Paid</div>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div style={{ background:"rgba(167,139,250,0.06)", border:"1px solid rgba(167,139,250,0.2)",
          borderRadius:12, padding:"12px 16px", display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:18 }}>📋</span>
          <div style={{ flex:1 }}>
            <div style={{ color:"#a78bfa", fontSize:12, fontWeight:700 }}>Zakat History · Pro</div>
            <div style={{ color:C.text3, fontSize:11, marginTop:2 }}>Record every payment — who you paid, when, how much</div>
          </div>
          <button onClick={() => openUpgrade && openUpgrade("zakat_history")}
            style={{ background:"linear-gradient(135deg,#a78bfa,#7c3aed)", border:"none",
              color:"#fff", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
            Upgrade
          </button>
        </div>
      )}
    </div>
  );
}

// ── SAVINGS GOALS ─────────────────────────────────────────────
function GoalsTab({ goals, setGoals, setTransactions, freeLimit, openUpgrade }) {
  const [modal, setModal] = useState(false);
  const [name,  setName]  = useState("🕋 Hajj Fund");
  const [target,setTarget]= useState("");
  const [saved, setSaved] = useState("");
  const [emoji, setEmoji] = useState("🕋");
  const [note,  setNote]  = useState("");
  const [customAmt, setCustomAmt] = useState({});
  const [goalContextModal, setGoalContextModal] = useState(null); // { name, context }

  const PRESETS = [
    { emoji:"🕋", name:"Hajj Fund",         note:"Saving for the journey of a lifetime",  context:"Hajj is obligatory for every Muslim who is physically and financially able. Once your savings reach nisab and stay there for a lunar year, Zakat applies — plan accordingly." },
    { emoji:"🏠", name:"Halal House",        note:"Riba-free home ownership",              context:"Avoid riba-based mortgages where possible. Look into Manzil (Canada) or Al Rayan Bank (UK) for Islamic home finance. Every payment on a halal mortgage is an act of worship." },
    { emoji:"💍", name:"Mahr",               note:"Her right — not a gift",                context:"Mahr is the bride's property — not a gift, not optional. Set a meaningful amount. Scholars recommend it be substantial enough to demonstrate sincerity." },
    { emoji:"📚", name:"Education Fund",     note:"Seek knowledge — avoid riba loans",     context:"Seeking knowledge is an obligation in Islam. Plan to avoid student loans (riba). Scholarship research and savings started early make riba-free education achievable." },
    { emoji:"🌙", name:"Emergency Fund",     note:"Tawakkul + preparation",               context:"The Prophet ﷺ tied his camel before trusting in Allah. 3-6 months of expenses is the scholarly-recommended minimum. This is tawakkul in action, not lack of faith." },
    { emoji:"🤲", name:"Sadaqah Jariya",     note:"Ongoing charity investment",            context:"Sadaqah Jariya continues to benefit you after death — a well, a Quran, knowledge that is acted upon. Earmark this fund for something permanent." },
  ];

  const add = () => {
    if (!name || !target) return;
    setGoals(prev => [...prev, { id:Date.now(), name, target:parseFloat(target), saved:parseFloat(saved)||0, emoji, note, createdAt:todayStr() }]);
    setModal(false); setName("🕋 Hajj Fund"); setTarget(""); setSaved(""); setNote(""); setEmoji("🕋");
  };

  const addToGoal = (goalId, amount, goalName, goalEmoji) => {
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) return;
    setGoals(prev => prev.map(g => g.id===goalId ? {...g, saved:Math.min(g.target, g.saved+amt)} : g));
    setTransactions(prev => [{
      id: Date.now(),
      date: todayStr(),
      description: `${goalEmoji} Savings → ${goalName}`,
      amount: -amt,
      expenseCategory: "Savings",
      category: "Need",
      isGoalContribution: true,
      goalId,
    }, ...prev]);
    setCustomAmt(prev => ({ ...prev, [goalId]: "" }));
  };

  const del = (goalId) => {
    setGoals(prev => prev.filter(g => g.id!==goalId));
    // Reverse all goal contribution transactions for this goal
    setTransactions(prev => prev.filter(t => !(t.isGoalContribution && t.goalId===goalId)));
  };

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:18 }}>
        <div>
          <div style={{ color:C.text, fontSize:18, fontWeight:800, letterSpacing:"-0.02em", marginBottom:3 }}>🎯 Goals</div>
          <div style={{ color:C.text3, fontSize:12 }}>
            {goals.length === 0 ? "No goals yet" : `${fmt(goals.reduce((s,g)=>s+g.saved,0))} saved of ${fmt(goals.reduce((s,g)=>s+g.target,0))}`}
          </div>
        </div>
        {freeLimit && goals.length >= freeLimit
          ? <button onClick={() => openUpgrade && openUpgrade("goals_unlimited")}
              style={{ background:"rgba(167,139,250,0.1)", border:"1px solid rgba(167,139,250,0.3)",
                color:"#a78bfa", borderRadius:10, padding:"7px 12px", fontSize:12, fontWeight:600, cursor:"pointer" }}>
              ✨ Upgrade for more
            </button>
          : <Btn onClick={() => setModal(true)} style={{ padding:"7px 12px", fontSize:12 }}>+ New Goal</Btn>
        }
      </div>

      {goals.length===0 && !modal && (
        <div style={{ textAlign:"center", padding:"32px 0" }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🕋</div>
          <div style={{ color:C.text2, fontSize:14, fontWeight:600, marginBottom:6 }}>Set your first savings goal</div>
          <div style={{ color:C.text3, fontSize:12 }}>Hajj, halal house, emergency fund, mahr…</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:8, justifyContent:"center", marginTop:16 }}>
            {PRESETS.map(p => (
              <button key={p.name} onClick={() => { setName(p.name); setEmoji(p.emoji); setNote(p.note); setModal(true); }}
                style={{ background:C.surface2, border:`1px solid ${C.border}`, color:C.text2, borderRadius:10, padding:"8px 14px", fontSize:12, cursor:"pointer" }}>
                {p.emoji} {p.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Islamic context modal for existing goals */}
      {goalContextModal && (
        <div style={{
          position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:500,
          display:"flex", alignItems:"center", justifyContent:"center", padding:20,
        }} onClick={() => setGoalContextModal(null)}>
          <div onClick={e => e.stopPropagation()} style={{
            background:C.surface2, border:`1px solid rgba(245,166,35,0.25)`,
            borderRadius:16, padding:20, maxWidth:400, width:"100%",
          }}>
            <div style={{ color:C.gold, fontWeight:800, fontSize:16, marginBottom:12 }}>
              🌙 {goalContextModal.name}
            </div>
            <div style={{ color:C.text2, fontSize:13, lineHeight:1.7 }}>
              {goalContextModal.context}
            </div>
            <button onClick={() => setGoalContextModal(null)} style={{
              width:"100%", marginTop:16, padding:"10px", borderRadius:10,
              background:C.surface3, border:`1px solid ${C.border}`,
              color:C.text2, fontSize:13, fontWeight:600, cursor:"pointer",
            }}>Close</button>
          </div>
        </div>
      )}

      {freeLimit && goals.length >= freeLimit && (
        <div style={{ background:"rgba(167,139,250,0.07)", border:"1px solid rgba(167,139,250,0.2)",
          borderRadius:12, padding:"12px 16px", marginBottom:10, display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:20 }}>🎯</span>
          <div style={{ flex:1 }}>
            <div style={{ color:"#a78bfa", fontSize:12, fontWeight:700 }}>Free plan: 3 goals max</div>
            <div style={{ color:C.text3, fontSize:11, marginTop:2 }}>Unlock unlimited goals — Hajj fund, Mahr, Sadaqah Jariya, all tracked. CA$4.99/month.</div>
          </div>
          <button onClick={() => openUpgrade && openUpgrade("goals_unlimited")}
            style={{ background:"linear-gradient(135deg,#a78bfa,#7c3aed)", border:"none",
              color:"#fff", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
            Upgrade
          </button>
        </div>
      )}
      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {goals.map(g => {
          const pct = g.target > 0 ? (g.saved/g.target)*100 : 0;
          const remaining = g.target - g.saved;
          const done = pct >= 100;
          const matchedPreset = PRESETS.find(p => p.name === g.name);
          return (
            <div key={g.id} style={{ background:C.surface2, border:`1px solid ${done ? "rgba(61,214,140,0.3)":C.border}`, borderRadius:14, padding:"14px 16px" }}>
              <div style={{ display:"flex", alignItems:"flex-start", gap:12, marginBottom:10 }}>
                <div style={{ fontSize:26 }}>{g.emoji}</div>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ color:C.text, fontWeight:700, fontSize:14 }}>{g.name}</span>
                    {matchedPreset && (
                      <button
                        onClick={() => setGoalContextModal({ name: g.name, context: matchedPreset.context })}
                        title="Islamic context"
                        style={{ background:"rgba(245,166,35,0.1)", border:"1px solid rgba(245,166,35,0.25)",
                          borderRadius:6, padding:"1px 7px", fontSize:11, cursor:"pointer",
                          color:C.gold, fontWeight:700, lineHeight:1.5 }}>
                        ℹ️
                      </button>
                    )}
                  </div>
                  {g.note && <div style={{ color:C.text3, fontSize:11, marginTop:2 }}>{g.note}</div>}
                </div>
                <button onClick={() => del(g.id)} style={{ background:"none", border:"none", color:C.text3, cursor:"pointer", fontSize:14 }}>✕</button>
              </div>
              <ProgressBar pct={pct} color={done ? C.green : C.purple} height={8} style={{ marginBottom:8 }} />
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div>
                  <span style={{ color: done ? C.green : C.text, fontWeight:700, fontSize:16 }}>{fmt(g.saved)}</span>
                  <span style={{ color:C.text3, fontSize:12 }}> / {fmt(g.target)}</span>
                </div>
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  {!done && <span style={{ color:C.text3, fontSize:11 }}>{fmt(remaining)} to go</span>}
                  {done && <Tag color={C.green}>✓ Goal reached!</Tag>}
                </div>
              </div>
              {!done && (
                <div style={{ marginTop:10 }}>
                  <div style={{ fontSize:10, color:C.text3, marginBottom:5, letterSpacing:"0.04em", textTransform:"uppercase" }}>Add from income</div>
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:6 }}>
                    {[25,50,100,200].map(a => (
                      <button key={a} onClick={() => addToGoal(g.id, a, g.name, g.emoji)}
                        style={{ background:C.surface3, border:`1px solid ${C.border}`, color:C.text2, borderRadius:8, padding:"5px 10px", fontSize:11, cursor:"pointer" }}>
                        +{fmt(a)}
                      </button>
                    ))}
                  </div>
                  <div style={{ display:"flex", gap:6 }}>
                    <input
                      type="number" placeholder="Custom amount…"
                      value={customAmt[g.id]||""}
                      onChange={e => setCustomAmt(prev => ({...prev, [g.id]: e.target.value}))}
                      style={{ flex:1, background:C.surface, border:`1px solid ${C.border}`, color:C.text, borderRadius:8, padding:"6px 10px", fontSize:12, outline:"none" }}
                    />
                    <button onClick={() => addToGoal(g.id, customAmt[g.id], g.name, g.emoji)}
                      disabled={!customAmt[g.id]}
                      style={{ background:C.greenDim, border:`1px solid ${C.green}`, color:C.green, borderRadius:8, padding:"6px 12px", fontSize:12, cursor:"pointer", fontWeight:600 }}>
                      Add
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {modal && (
        <div style={{ marginTop:14, background:C.surface3, border:`1px solid ${C.border2}`, borderRadius:14, padding:16 }}>
          <div style={{ color:C.text, fontWeight:600, marginBottom:12 }}>New Savings Goal</div>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:8 }}>
            {PRESETS.map(p => (
              <button key={p.name} onClick={() => { setName(p.name); setEmoji(p.emoji); setNote(p.note); }}
                style={{ background: name===p.name ? C.purpleDim : "transparent", border:`1px solid ${name===p.name ? C.purple : C.border}`, color: name===p.name ? C.purple : C.text3, borderRadius:8, padding:"5px 10px", fontSize:11, cursor:"pointer" }}>
                {p.emoji} {p.name}
              </button>
            ))}
          </div>

          {/* Islamic context card — shown when a preset is selected */}
          {(() => {
            const active = PRESETS.find(p => p.name === name);
            if (!active) return null;
            return (
              <div style={{
                background:"rgba(245,166,35,0.08)", border:"1px solid rgba(245,166,35,0.2)",
                borderRadius:12, padding:"12px 14px", marginBottom:12,
              }}>
                <div style={{ color:C.text2, fontSize:12, lineHeight:1.7 }}>
                  🌙 {active.context}
                </div>
              </div>
            );
          })()}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
            <Inp label="Goal Name" value={name} onChange={e=>setName(e.target.value)} />
            <Inp label="Target Amount" type="number" placeholder="15000" value={target} onChange={e=>setTarget(e.target.value)} />
            <Inp label="Already saved ($)" type="number" placeholder="0" value={saved} onChange={e=>setSaved(e.target.value)} />
            <Inp label="Note (optional)" value={note} onChange={e=>setNote(e.target.value)} />
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <Btn onClick={add}>Save Goal</Btn>
            <Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn>
          </div>
        </div>
      )}
    </div>
  );
}

// ── DEBT TAB ──────────────────────────────────────────────────
function DebtTab({ debtState, setDebtState, transactions, proUser, openUpgrade, freeLimit }) {
  const [modal, setModal] = useState(null);
  const [dName, setDName] = useState(""); const [dType, setDType] = useState("credit");
  const [dBal,  setDBal]  = useState(""); const [dRate, setDRate] = useState("");
  const [dMin,  setDMin]  = useState("");
  const [pDebt, setPDebt] = useState(""); const [pAmt,  setPAmt]  = useState("");
  const [pNote, setPNote] = useState(""); const [pMonth,setPMonth]= useState(thisMonthStr());

  const addDebt = () => {
    if (!dName || !dBal) return;
    setDebtState(p => ({ ...p, debts:[...p.debts,{id:Date.now(),name:dName,type:dType,originalBalance:parseFloat(dBal),currentBalance:parseFloat(dBal),rate:parseFloat(dRate)||0,minPayment:parseFloat(dMin)||0}] }));
    setModal(null); setDName(""); setDBal(""); setDRate(""); setDMin("");
  };

  const logPayment = () => {
    if (!pDebt || !pAmt) return;
    const amt = parseFloat(pAmt);
    setDebtState(p => ({
      payments:[...p.payments,{id:Date.now(),debtId:Number(pDebt),amount:amt,month:pMonth,note:pNote}],
      debts: p.debts.map(d => d.id!==Number(pDebt) ? d : {...d,currentBalance:Math.max(0,d.currentBalance-amt)}),
    }));
    setModal(null); setPAmt(""); setPNote("");
  };

  const delDebt = (id) => setDebtState(p => ({debts:p.debts.filter(d=>d.id!==id),payments:p.payments.filter(p=>p.debtId!==id)}));

  const totalRiba  = debtState.debts.filter(d=>getDebt(d.type).haram).reduce((s,d)=>s+d.currentBalance,0);
  const totalHalal = debtState.debts.filter(d=>!getDebt(d.type).haram).reduce((s,d)=>s+d.currentBalance,0);
  const totalPaid  = debtState.debts.reduce((s,d)=>s+(d.originalBalance-d.currentBalance),0);

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom:18 }}>
        <div style={{ color:C.text, fontSize:18, fontWeight:800, letterSpacing:"-0.02em", marginBottom:3 }}>💳 Debts</div>
        <div style={{ color:C.text3, fontSize:12 }}>
          {debtState.debts.length === 0 ? "No debts tracked" : `${fmt(totalRiba + totalHalal)} total outstanding · ${fmt(totalPaid)} paid off`}
        </div>
      </div>

      {/* Card purchases notice */}
      {(() => {
        const cp = transactions.filter(t=>t.cardId&&t.amount<0);
        if (!cp.length) return null;
        const total = cp.reduce((s,t)=>s+Math.abs(t.amount),0);
        return (
          <div style={{ background:C.redDim, border:`1px solid rgba(240,82,82,0.2)`, borderRadius:12, padding:"10px 14px", marginBottom:12, fontSize:12, color:"#f87171" }}>
            💳 <strong>{cp.length} purchases</strong> on credit cards this month — {fmt(total)} added to balances
          </div>
        );
      })()}

      {/* Overview stats */}
      {debtState.debts.length > 0 && (
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:16 }}>
          {[
            { label:"Riba Debt", val:fmt(totalRiba), color:C.red },
            { label:"Halal Debt", val:fmt(totalHalal), color:C.green },
            { label:"Paid Off", val:fmt(totalPaid), color:C.blue },
          ].map(s => (
            <div key={s.label} style={{ background:C.surface2, border:`1px solid ${C.border}`, borderRadius:12, padding:"12px 8px", textAlign:"center" }}>
              <div style={{ color:C.text3, fontSize:10, textTransform:"uppercase", fontWeight:600, letterSpacing:"0.04em", marginBottom:5 }}>{s.label}</div>
              <div style={{ color:s.color, fontWeight:700, fontSize:15 }}>{s.val}</div>
            </div>
          ))}
        </div>
      )}

      {/* Halal Debt Coaching — Pro */}
      {debtState.debts.length > 1 && (() => {
        const ribadebts = debtState.debts.filter(d => getDebt(d.type).haram && d.currentBalance > 0);
        if (!ribadebts.length) return null;

        // Avalanche = highest APR first (saves most money)
        const avalanche = [...ribadebts].sort((a,b) => b.rate - a.rate);
        // Snowball = smallest balance first (psychological wins)
        const snowball  = [...ribadebts].sort((a,b) => a.currentBalance - b.currentBalance);

        if (!proUser) return (
          <div style={{ background:"rgba(167,139,250,0.06)", border:"1px solid rgba(167,139,250,0.2)",
            borderRadius:12, padding:"12px 16px", marginBottom:14, display:"flex", alignItems:"center", gap:10 }}>
            <span style={{ fontSize:20 }}>🎯</span>
            <div style={{ flex:1 }}>
              <div style={{ color:"#a78bfa", fontSize:12, fontWeight:700 }}>Halal Payoff Strategy · Pro</div>
              <div style={{ color:C.text3, fontSize:11, marginTop:2 }}>Avalanche vs snowball — see which saves you more money</div>
            </div>
            <button onClick={() => openUpgrade && openUpgrade("debt_tracker")}
              style={{ background:"linear-gradient(135deg,#a78bfa,#7c3aed)", border:"none",
                color:"#fff", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
              Unlock
            </button>
          </div>
        );

        // Islamic Priority: riba debts first (by APR), then halal debts (by APR)
        const islamic = [
          ...ribadebts.filter(d => getDebt(d.type).haram).sort((a,b) => b.rate - a.rate),
          ...debtState.debts.filter(d => !getDebt(d.type).haram && d.currentBalance > 0).sort((a,b) => b.rate - a.rate),
        ];

        // Calculate total interest paid under each strategy
        const calcTotalInterest = (orderedDebts) => {
          let totalInterest = 0;
          let freed = 0; // freed up payment from paid-off debts
          const debts = orderedDebts.map(d => ({ ...d, bal: d.currentBalance }));
          for (let month = 0; month < 360; month++) {
            let allPaid = true;
            for (let i = 0; i < debts.length; i++) {
              if (debts[i].bal <= 0) continue;
              allPaid = false;
              const interest = debts[i].bal * (debts[i].rate / 100 / 12);
              const mp = debts[i].minPayment || debts[i].minpayment || 100;
              const payment = i === 0 ? mp + freed : mp;
              totalInterest += interest;
              debts[i].bal = Math.max(0, debts[i].bal + interest - payment);
              if (debts[i].bal === 0) freed += (debts[i].minPayment || debts[i].minpayment || 100);
            }
            if (allPaid) break;
          }
          return totalInterest;
        };

        const avalancheInterest = calcTotalInterest(avalanche);
        const snowballInterest  = calcTotalInterest(snowball);
        const islamicInterest   = calcTotalInterest(islamic);
        const interestSaved = Math.abs(snowballInterest - avalancheInterest);
        const islamicVsAvalanche = islamicInterest - avalancheInterest;

        // Total months to debt free
        const totalDebt = ribadebts.reduce((s,d) => s + d.currentBalance, 0);
        const totalMin  = ribadebts.reduce((s,d) => s + (d.minPayment || 100), 0);
        const monthsFree = calcPayoff(totalDebt, ribadebts[0]?.rate || 10, totalMin);

        return (
          <div style={{ background:"rgba(240,82,82,0.05)", border:"1px solid rgba(240,82,82,0.15)", borderRadius:12, padding:"14px 16px", marginBottom:14 }}>
            <div style={{ color:C.red, fontWeight:700, fontSize:13, marginBottom:4 }}>🎯 Halal Payoff Strategy</div>
            <div style={{ color:C.text3, fontSize:11, marginBottom:12 }}>
              At minimum payments: debt-free in <strong style={{color:C.amber}}>{monthsFree===Infinity?"never":`${Math.floor(monthsFree/12)}y ${monthsFree%12}m`}</strong> · Pay extra to get there faster
            </div>

            {/* Recommendation */}
            {(() => {
              const sameOrder = avalanche.every((d,i) => d.id === snowball[i]?.id);
              return (
                <div style={{ background:"rgba(61,214,140,0.07)", border:"1px solid rgba(61,214,140,0.2)", borderRadius:10, padding:"10px 14px", marginBottom:12 }}>
                  {sameOrder ? (
                    <>
                      <div style={{ color:C.green, fontWeight:700, fontSize:12, marginBottom:4 }}>✓ Both strategies agree</div>
                      <div style={{ color:C.text2, fontSize:11, lineHeight:1.5 }}>
                        Your debts happen to be in the same order for both methods. Focus all extra money on <strong style={{color:C.text}}>{avalanche[0]?.name}</strong> first, then move to the next once it's gone. This is called the <em>debt snowball / avalanche</em> — when one debt is paid off, you roll that payment into the next one.
                      </div>
                    </>
                  ) : interestSaved > 10 ? (
                    <>
                      <div style={{ color:C.green, fontWeight:700, fontSize:12, marginBottom:4 }}>✓ Recommended: Avalanche — saves you {fmt(interestSaved)}</div>
                      <div style={{ color:C.text2, fontSize:11, lineHeight:1.5 }}>
                        Attack <strong style={{color:C.text}}>{avalanche[0]?.name}</strong> ({avalanche[0]?.rate}% APR) first even though it's bigger — you'll pay {fmt(interestSaved)} less in riba interest total. If you need motivation, use Snowball instead (smaller wins first).
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ color:C.green, fontWeight:700, fontSize:12, marginBottom:4 }}>✓ Recommended: Snowball</div>
                      <div style={{ color:C.text2, fontSize:11, lineHeight:1.5 }}>
                        The interest difference is small ({fmt(interestSaved)}). Go with Snowball — paying off <strong style={{color:C.text}}>{snowball[0]?.name}</strong> first gives you a quick win and keeps you motivated.
                      </div>
                    </>
                  )}
                </div>
              );
            })()}

            {/* Strategy cards — scrollable row */}
            <div style={{ display:"flex", gap:10, overflowX:"auto", paddingBottom:4, WebkitOverflowScrolling:"touch" }}>

              {/* Islamic Priority */}
              <div style={{ background:"linear-gradient(135deg,rgba(251,191,36,0.08),rgba(251,191,36,0.03))", border:"1px solid rgba(251,191,36,0.25)", borderRadius:10, padding:"10px 12px", minWidth:170, flexShrink:0 }}>
                <div style={{ color:C.gold, fontWeight:700, fontSize:11, marginBottom:2 }}>🕌 Islamic Priority</div>
                <div style={{ color:C.text3, fontSize:10, marginBottom:8 }}>Riba debts first, halal last</div>
                {islamic.map((d,i) => {
                  const isHaram = getDebt(d.type).haram;
                  return (
                    <div key={d.id} style={{ display:"flex", alignItems:"center", gap:6, marginBottom:6, padding:"6px 8px", background: i===0?"rgba(251,191,36,0.1)":"transparent", borderRadius:8 }}>
                      <span style={{ color: i===0?C.gold:C.text3, fontSize:11, minWidth:16, fontWeight:700 }}>{i+1}.</span>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ color:C.text, fontSize:11, fontWeight: i===0?700:400, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{d.name}</div>
                        <div style={{ fontSize:10 }}>
                          <span style={{ color: isHaram?C.red:"#86efac" }}>{isHaram?"⚠️ Riba":"✓ Halal"}</span>
                          <span style={{ color:C.text3 }}> · {d.rate}%</span>
                        </div>
                      </div>
                      {i===0 && <span style={{ color:C.gold, fontSize:9, fontWeight:700 }}>FIRST</span>}
                    </div>
                  );
                })}
                {islamicVsAvalanche > 0.5 && (
                  <div style={{ color:C.text3, fontSize:10, marginTop:6, lineHeight:1.4 }}>
                    Costs ~{fmt(islamicVsAvalanche)} more in interest but eliminates haram debt first — the Islamic choice.
                  </div>
                )}
                {islamicVsAvalanche <= 0.5 && (
                  <div style={{ color:C.green, fontSize:10, marginTop:6 }}>Same interest cost as avalanche ✓</div>
                )}
              </div>

              {/* Avalanche */}
              <div style={{ background:C.surface2, borderRadius:10, padding:"10px 12px", minWidth:160, flexShrink:0 }}>
                <div style={{ color:C.amber, fontWeight:700, fontSize:11, marginBottom:2 }}>⚡ Avalanche</div>
                <div style={{ color:C.text3, fontSize:10, marginBottom:8 }}>Highest APR first · {fmt(avalancheInterest)} total interest</div>
                {avalanche.map((d,i) => (
                  <div key={d.id} style={{ display:"flex", alignItems:"center", gap:6, marginBottom:6, padding:"6px 8px", background: i===0?"rgba(245,166,35,0.08)":"transparent", borderRadius:8 }}>
                    <span style={{ color: i===0?C.amber:C.text3, fontSize:11, minWidth:16, fontWeight:700 }}>{i+1}.</span>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ color:C.text, fontSize:11, fontWeight: i===0?700:400, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{d.name}</div>
                      <div style={{ color:C.red, fontSize:10 }}>{d.rate}% · {fmt(d.currentBalance)}</div>
                    </div>
                    {i===0 && <span style={{ color:C.amber, fontSize:9, fontWeight:700 }}>FIRST</span>}
                  </div>
                ))}
              </div>

              {/* Snowball */}
              <div style={{ background:C.surface2, borderRadius:10, padding:"10px 12px", minWidth:160, flexShrink:0 }}>
                <div style={{ color:C.green, fontWeight:700, fontSize:11, marginBottom:2 }}>🎯 Snowball</div>
                <div style={{ color:C.text3, fontSize:10, marginBottom:8 }}>Smallest balance first · quick wins</div>
                {snowball.map((d,i) => (
                  <div key={d.id} style={{ display:"flex", alignItems:"center", gap:6, marginBottom:6, padding:"6px 8px", background: i===0?"rgba(61,214,140,0.08)":"transparent", borderRadius:8 }}>
                    <span style={{ color: i===0?C.green:C.text3, fontSize:11, minWidth:16, fontWeight:700 }}>{i+1}.</span>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ color:C.text, fontSize:11, fontWeight: i===0?700:400, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{d.name}</div>
                      <div style={{ color:C.blue, fontSize:10 }}>{fmt(d.currentBalance)} remaining</div>
                    </div>
                    {i===0 && <span style={{ color:C.green, fontSize:9, fontWeight:700 }}>FIRST</span>}
                  </div>
                ))}
              </div>
            </div>
            <div style={{ color:C.text3, fontSize:10, marginTop:10, textAlign:"center", lineHeight:1.5 }}>
              Islamic guidance: every riyal/dollar of riba interest is haram. Pay off all riba debt as fast as possible before investing.
            </div>
          </div>
        );
      })()}

      {/* Free limit upgrade banner */}
      {freeLimit && debtState.debts.length >= freeLimit && (
        <div style={{ background:"rgba(167,139,250,0.07)", border:"1px solid rgba(167,139,250,0.2)",
          borderRadius:12, padding:"12px 16px", marginBottom:14, display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:20 }}>💳</span>
          <div style={{ flex:1 }}>
            <div style={{ color:"#a78bfa", fontSize:12, fontWeight:700 }}>Free plan: {freeLimit} debts max</div>
            <div style={{ color:C.text3, fontSize:11, marginTop:2 }}>
              Unlock unlimited debt tracking — clear your riba faster with the full payoff planner. CA$4.99/month.
            </div>
          </div>
          <button onClick={() => openUpgrade && openUpgrade("debt_unlimited")}
            style={{ background:"linear-gradient(135deg,#a78bfa,#7c3aed)", border:"none",
              color:"#fff", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
            Upgrade
          </button>
        </div>
      )}

      {/* Actions */}
      {!modal && (
        <div style={{ display:"flex", gap:8, marginBottom:14 }}>
          {freeLimit && debtState.debts.length >= freeLimit
            ? <button onClick={() => openUpgrade && openUpgrade("debt_unlimited")}
                style={{ flex:1, background:"rgba(167,139,250,0.1)", border:"1px solid rgba(167,139,250,0.3)",
                  color:"#a78bfa", borderRadius:10, padding:"11px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
                ✨ Upgrade to add more debts
              </button>
            : <Btn onClick={() => setModal("add")} style={{ flex:1 }}>+ Add Debt</Btn>
          }
          {debtState.debts.length>0 && <Btn onClick={() => setModal("pay")} variant="ghost" style={{ flex:1 }}>💸 Log Payment</Btn>}
        </div>
      )}

      {modal==="add" && (
        <Card style={{ marginBottom:14, borderColor:"rgba(96,165,250,0.2)", background:C.surface2 }}>
          <div style={{ color:C.text, fontWeight:600, marginBottom:12 }}>Add Debt</div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
            <Inp label="Name" placeholder="TD Visa" value={dName} onChange={e=>setDName(e.target.value)} />
            <Sel label="Type" value={dType} onChange={e=>setDType(e.target.value)}>
              {DEBT_TYPES.map(d=><option key={d.id} value={d.id}>{d.icon} {d.label}</option>)}
            </Sel>
            <Inp label="Balance" type="number" placeholder="5000" value={dBal} onChange={e=>setDBal(e.target.value)} />
            <Inp label="APR (%)" type="number" placeholder="19.99" value={dRate} onChange={e=>setDRate(e.target.value)} />
            <div style={{ gridColumn:"1/-1" }}>
              <Inp label="Min. Payment" type="number" placeholder="150" value={dMin} onChange={e=>setDMin(e.target.value)} />
            </div>
          </div>
          {getDebt(dType).haram && (
            <div style={{ background:C.redDim, border:`1px solid rgba(240,82,82,0.2)`, borderRadius:10, padding:"8px 12px", fontSize:11, color:"#f87171", marginBottom:10 }}>
              ⚠️ This involves riba (interest). Prioritise eliminating it.
            </div>
          )}
          <div style={{ display:"flex", gap:8 }}>
            <Btn onClick={addDebt}>Save</Btn>
            <Btn variant="ghost" onClick={()=>setModal(null)}>Cancel</Btn>
          </div>
        </Card>
      )}

      {modal==="pay" && (
        <Card style={{ marginBottom:14, borderColor:"rgba(61,214,140,0.2)", background:C.surface2 }}>
          <div style={{ color:C.text, fontWeight:600, marginBottom:12 }}>Log Payment</div>
          <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:12 }}>
            <Sel label="Debt" value={pDebt} onChange={e=>setPDebt(e.target.value)}>
              <option value="">Select…</option>
              {debtState.debts.map(d=><option key={d.id} value={d.id}>{getDebt(d.type).icon} {d.name} — {fmt(d.currentBalance)}</option>)}
            </Sel>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
              <Inp label="Amount" type="number" placeholder="250" value={pAmt} onChange={e=>setPAmt(e.target.value)} />
              <Inp label="Month" type="month" value={pMonth} onChange={e=>setPMonth(e.target.value)} />
            </div>
            <Inp label="Note" placeholder="Extra payment…" value={pNote} onChange={e=>setPNote(e.target.value)} />
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <Btn onClick={logPayment} disabled={!pDebt||!pAmt}>Save</Btn>
            <Btn variant="ghost" onClick={()=>setModal(null)}>Cancel</Btn>
          </div>
        </Card>
      )}

      {/* Debt cards */}
      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {debtState.debts.map(debt => {
          const dt = getDebt(debt.type);
          const paid = debt.originalBalance - debt.currentBalance;
          const pct  = Math.min(100, debt.originalBalance>0 ? (paid/debt.originalBalance)*100 : 0);
          const months = calcPayoff(debt.currentBalance, debt.rate, debt.minPayment);
          const monthlyInterest = (debt.currentBalance * (debt.rate/100)) / 12;
          return (
            <div key={debt.id} style={{ background:C.surface2, border:`1px solid ${dt.color}22`, borderRadius:14, padding:"14px 16px" }}>
              <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10 }}>
                <div style={{ fontSize:24 }}>{dt.icon}</div>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ color:C.text, fontWeight:700, fontSize:14 }}>{debt.name}</span>
                    <Tag color={dt.color}>{dt.label}</Tag>
                    {debt.currentBalance<=0 && <Tag color={C.green}>✓ Paid off</Tag>}
                  </div>
                  {dt.haram && monthlyInterest>0 && (
                    <div style={{ color:"#f87171", fontSize:11, marginTop:2 }}>~{fmt(monthlyInterest)}/mo in interest ⚠️</div>
                  )}
                </div>
                <button onClick={()=>delDebt(debt.id)} style={{ background:C.redDim, border:"none", color:C.red, borderRadius:8, padding:"5px 9px", fontSize:11, cursor:"pointer" }}>✕</button>
              </div>
              <div style={{ display:"flex", gap:16, marginBottom:10, flexWrap:"wrap" }}>
                <div><div style={{ color:C.text3, fontSize:9, fontWeight:600, textTransform:"uppercase" }}>Remaining</div><div style={{ color:dt.color, fontWeight:800, fontSize:18 }}>{fmt(debt.currentBalance)}</div></div>
                <div><div style={{ color:C.text3, fontSize:9, fontWeight:600, textTransform:"uppercase" }}>Original</div><div style={{ color:C.text2, fontWeight:600, fontSize:13 }}>{fmt(debt.originalBalance)}</div></div>
                <div><div style={{ color:C.text3, fontSize:9, fontWeight:600, textTransform:"uppercase" }}>Paid</div><div style={{ color:C.green, fontWeight:600, fontSize:13 }}>{fmt(paid)}</div></div>
                {months!==Infinity&&months>0&&<div><div style={{ color:C.text3, fontSize:9, fontWeight:600, textTransform:"uppercase" }}>Payoff</div><div style={{ color:C.amber, fontWeight:600, fontSize:13 }}>{Math.floor(months/12)>0?`${Math.floor(months/12)}y `:""}{ months%12}m</div></div>}
              </div>
              <ProgressBar pct={pct} color={dt.color} height={6} />
              <div style={{ color:C.text3, fontSize:10, marginTop:4 }}>{pct.toFixed(1)}% paid off</div>
            </div>
          );
        })}
      </div>

      {debtState.debts.length===0 && !modal && (
        <div style={{ textAlign:"center", padding:"28px 0", color:C.text3, fontSize:13 }}>
          <div style={{ fontSize:28, marginBottom:8 }}>📋</div>
          <div style={{ color:C.text2, fontWeight:600, marginBottom:4 }}>No debts — alhamdulillah.</div>
          If you carry riba debt, tracking it is the first step to freedom. Add credit cards, car loans, or a mortgage above.
        </div>
      )}

      <div style={{ marginTop:16, background:"rgba(167,139,250,0.05)", border:`1px solid rgba(167,139,250,0.1)`, borderRadius:12, padding:"12px 16px", textAlign:"center" }}>
        <div style={{ color:C.text3, fontSize:11, fontStyle:"italic", lineHeight:1.7 }}>
          The Prophet ﷺ said: <em style={{ color:"#c4b5fd" }}>"O Allah, I seek refuge in You from sin and heavy debt."</em> 🤲
        </div>
      </div>
    </div>
  );
}



// ── BUDGET PRESETS ────────────────────────────────────────────
const BUDGET_PRESETS = {
  islamicThirds: {
    label: "Islamic Thirds",
    emoji: "🕌",
    desc: "⅓ needs, ⅓ wants, ⅓ savings/sadaqah — inspired by Islamic financial wisdom",
    allocations: {
      "Rent": 0.30, "Groceries": 0.12, "Transport": 0.08,
      "Utilities": 0.05, "Health": 0.04, "Education": 0.04,
      "Clothing": 0.03, "Entertainment": 0.04, "Subscriptions": 0.02,
      "Savings": 0.15, "Sadaqah": 0.08, "Food": 0.025, "Shopping": 0.025,
    },
  },
  balanced: {
    label: "Balanced (50/30/20)",
    emoji: "⚖️",
    desc: "50% needs, 30% wants, 20% savings — classic budgeting adapted for Muslims",
    allocations: {
      "Rent": 0.28, "Groceries": 0.12, "Transport": 0.10,
      "Utilities": 0.05, "Health": 0.04, "Education": 0.03,
      "Shopping": 0.04, "Entertainment": 0.06, "Subscriptions": 0.03,
      "Savings": 0.12, "Sadaqah": 0.05, "Food": 0.025, "Phone": 0.025,
    },
  },
  conservative: {
    label: "Conservative",
    emoji: "🛡️",
    desc: "Maximise savings and giving — for those paying off debt or building emergency fund",
    allocations: {
      "Rent": 0.25, "Groceries": 0.10, "Transport": 0.08,
      "Utilities": 0.05, "Health": 0.03, "Education": 0.03,
      "Shopping": 0.02, "Entertainment": 0.02, "Subscriptions": 0.01,
      "Savings": 0.20, "Sadaqah": 0.10, "Food": 0.025, "Phone": 0.025,
    },
  },
};

// ── BUDGET EDIT (free: preset picker; Pro: manual control) ────
function BudgetEditTab({ budgetData, setBudgetData, settings, proUser, openUpgrade }) {
  const CATS_BUDGET = [
    { id:"Rent",          label:"Rent",       emoji:"🏠" },
    { id:"Groceries",     label:"Groceries",  emoji:"🛒" },
    { id:"Food",          label:"Dining",     emoji:"🍜" },
    { id:"Transport",     label:"Transport",  emoji:"🚗" },
    { id:"Utilities",     label:"Utilities",  emoji:"💡" },
    { id:"Phone",         label:"Phone",      emoji:"📱" },
    { id:"Subscriptions", label:"Subs",       emoji:"📺" },
    { id:"Shopping",      label:"Shopping",   emoji:"🛍" },
    { id:"Health",        label:"Health",     emoji:"💊" },
    { id:"Education",     label:"Education",  emoji:"📚" },
    { id:"Entertainment", label:"Fun",        emoji:"🎮" },
    { id:"Sadaqah",       label:"Sadaqah",    emoji:"🤲" },
    { id:"Savings",       label:"Savings",    emoji:"💰" },
  ];

  const existingIncome = budgetData?.income || budgetData?.monthlyIncome || 0;
  const [income, setIncome] = useState(existingIncome.toString());
  const [amounts, setAmounts] = useState(() => {
    const b = budgetData?.budgets || {};
    const inc = existingIncome;
    const allocs = budgetData?.allocs || [];
    const result = {};
    CATS_BUDGET.forEach(c => {
      if (b[c.id] != null) result[c.id] = b[c.id].toString();
      else {
        const a = allocs.find(x => x.cat === c.id);
        result[c.id] = a && inc > 0 ? Math.round(inc * a.pct / 100).toString() : "";
      }
    });
    return result;
  });
  const [saved, setSaved] = useState(false);
  const [presetApplied, setPresetApplied] = useState(null);

  const inc = parseFloat(income) || 0;
  const totalAmt = CATS_BUDGET.reduce((s,c) => s + (parseFloat(amounts[c.id]) || 0), 0);
  const remaining = inc - totalAmt;
  const sym = settings?.currencySymbol || "$";

  const applyPreset = (presetKey) => {
    if (!inc) return;
    const preset = BUDGET_PRESETS[presetKey];
    if (!preset) return;
    const newAmounts = {};
    CATS_BUDGET.forEach(c => {
      const pct = preset.allocations[c.id] || 0;
      newAmounts[c.id] = pct > 0 ? Math.round(inc * pct).toString() : "";
    });
    setAmounts(newAmounts);
    setPresetApplied(presetKey);
    // Auto-save preset result immediately
    const budgets = {};
    const allocsArray = [];
    CATS_BUDGET.forEach(c => {
      const amt = parseFloat(newAmounts[c.id]) || 0;
      budgets[c.id] = amt;
      allocsArray.push({ cat: c.id, pct: inc > 0 ? Math.round(amt/inc*100) : 0, icon: c.emoji, tip: c.label });
    });
    const data = { income: inc, allocs: allocsArray, budgets };
    setBudgetData(data);
    localStorage.setItem("bb_budgets_v1", JSON.stringify(data));
  };

  const handleSave = () => {
    const budgets = {};
    const allocsArray = [];
    CATS_BUDGET.forEach(c => {
      const amt = parseFloat(amounts[c.id]) || 0;
      budgets[c.id] = amt;
      allocsArray.push({ cat: c.id, pct: inc > 0 ? Math.round(amt/inc*100) : 0, icon: c.emoji, tip: c.label });
    });
    const data = { income: inc, allocs: allocsArray, budgets };
    setBudgetData(data);
    localStorage.setItem("bb_budgets_v1", JSON.stringify(data));
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div style={{ paddingBottom:8 }}>
      {/* Income row */}
      <div style={{ background:C.surface2, borderRadius:12, padding:"12px 14px", marginBottom:12,
        display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <span style={{ color:C.text3, fontSize:12, fontWeight:600 }}>Monthly income</span>
        <div style={{ display:"flex", alignItems:"center", gap:4 }}>
          <span style={{ color:C.text3, fontSize:12 }}>{sym}</span>
          <input type="number" value={income} onChange={e => setIncome(e.target.value)}
            placeholder="0"
            style={{ width:90, background:"none", border:"none", color:C.green, fontSize:15,
              fontWeight:800, fontFamily:"'DM Sans',sans-serif", outline:"none", textAlign:"right" }} />
        </div>
      </div>

      {/* ── Preset picker — ALL users ── */}
      <div style={{ marginBottom:14 }}>
        <div style={{ fontSize:10, fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3, marginBottom:8 }}>Budget Presets</div>
        {!inc ? (
          <div style={{ background:"rgba(245,166,35,0.07)", border:"1px solid rgba(245,166,35,0.2)", borderRadius:10, padding:"10px 14px", fontSize:12, color:C.amber }}>
            Set your monthly income above, then choose a preset to auto-fill your budget.
          </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {Object.entries(BUDGET_PRESETS).map(([key, preset]) => {
              const isActive = presetApplied === key;
              return (
                <button key={key} onClick={() => applyPreset(key)} style={{
                  background: isActive ? "rgba(167,139,250,0.12)" : C.surface2,
                  border: `1px solid ${isActive ? "rgba(167,139,250,0.4)" : C.border}`,
                  borderRadius:12, padding:"12px 14px", cursor:"pointer", textAlign:"left",
                  transition:"all 0.15s",
                }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                    <span style={{ fontSize:16 }}>{preset.emoji}</span>
                    <span style={{ color: isActive ? C.purple : C.text, fontWeight:700, fontSize:13 }}>{preset.label}</span>
                    {isActive && <span style={{ background:"rgba(167,139,250,0.2)", color:C.purple, fontSize:9, fontWeight:700, borderRadius:4, padding:"2px 6px" }}>APPLIED</span>}
                  </div>
                  <div style={{ color:C.text3, fontSize:11, lineHeight:1.5 }}>{preset.desc}</div>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* ── Manual per-category editing — Pro only ── */}
      {proUser ? (
        <>
          <div style={{ fontSize:10, fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase", color:C.text3, marginBottom:8 }}>Manual Adjustments</div>
          {/* Category grid — 2 columns */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:6, marginBottom:10 }}>
            {CATS_BUDGET.map(c => (
              <div key={c.id} style={{ background:C.surface2, borderRadius:10, padding:"9px 10px",
                display:"flex", alignItems:"center", justifyContent:"space-between", gap:4 }}>
                <span style={{ fontSize:13, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis",
                  color:C.text2, flex:1 }}>{c.emoji} {c.label}</span>
                <input type="number" value={amounts[c.id] || ""} placeholder="0"
                  onChange={e => setAmounts(prev => ({ ...prev, [c.id]: e.target.value }))}
                  style={{ width:56, background:"none", border:"none", color:C.text, fontSize:13,
                    fontWeight:700, fontFamily:"'DM Sans',sans-serif", outline:"none", textAlign:"right" }} />
              </div>
            ))}
          </div>

          {/* Balance indicator */}
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10,
            background: Math.abs(remaining)<1 ? "rgba(61,214,140,0.08)" : "rgba(245,166,35,0.08)",
            borderRadius:8, padding:"8px 12px" }}>
            <span style={{ color:C.text3, fontSize:12 }}>Unallocated</span>
            <span style={{ fontSize:12, fontWeight:700, color: Math.abs(remaining)<1 ? C.green : C.amber }}>
              {remaining >= 0 ? "" : "−"}{sym}{Math.abs(remaining).toFixed(0)}
            </span>
          </div>

          <button onClick={handleSave}
            style={{ width:"100%", padding:"12px", borderRadius:10, border:"none", cursor:"pointer",
              background: saved ? "rgba(61,214,140,0.15)" : C.green,
              color: saved ? C.green : "#0e0e13", fontSize:14, fontWeight:700, transition:"all 0.2s" }}>
            {saved ? "✓ Saved" : "Save Budget"}
          </button>
        </>
      ) : (
        <div style={{ background:"rgba(167,139,250,0.06)", border:"1px solid rgba(167,139,250,0.2)", borderRadius:12, padding:"12px 16px", display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:18 }}>✏️</span>
          <div style={{ flex:1 }}>
            <div style={{ color:"#a78bfa", fontSize:12, fontWeight:700 }}>Custom budgets · Pro</div>
            <div style={{ color:C.text3, fontSize:11, marginTop:2 }}>Manually set each category. Free plan uses presets above.</div>
          </div>
          <button onClick={() => openUpgrade && openUpgrade("budget_manual")}
            style={{ background:"linear-gradient(135deg,#a78bfa,#7c3aed)", border:"none",
              color:"#fff", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
            Upgrade
          </button>
        </div>
      )}
    </div>
  );
}

export { RecurringTab, NetWorthTab, ZakatTab, GoalsTab, DebtTab, BudgetEditTab };